<!-- 产品组件 -->
<template>
  <div class="product-content footer">
    <div class="product-content-container">
      <div class="item" v-for="(item,index) in productList" :key="index">
        <div class="item-top">
          <div class="left-title"><span class="text">{{item.title}}</span></div>
          <div class="right-more" v-if="applyFilterBtn" @click="goRouter('centrifuge')">
              <div class="filter-button">
                    <img class="icon" src="@/assets/img/filtrate-icon-1.png" alt="">
                    <span class="text">根据应用筛选</span>
                    <i class="iconfont icon-youjiantou"></i>
                </div>
          </div>
          <div class="right-more" v-if="showMoreBtn" @click="moreProduct(item)">更多 <i class="iconfont icon-youjiantou"></i></div>
          <div v-if="category_id == 112 || category_id == 156" class="right-goto-sucker" @click="gotoSucker">
            <img src="https://cdn.juplus.cn/juplus2.0__1665467360_634503e0b7852.png" alt="">
            <span>吸头选型</span>
            <i class="iconfont icon-xiajiantou"></i>
          </div>
        </div>
        <div class="item-middle">
          <div v-if="showFiltrate">
            <div class="filtrate-container">
              <!--              <van-button type="default" v-for="(item,index) in conditionList" :key="index" color="#6cc4da" class="filter-btn" @click="conditionClick(item,index)">{{item.title}}<i class="iconfont icon-youjiantou"></i></van-button>-->
              <div class="item" v-for="(item,index) in conditionListDispose" :key="item.id">
                <div class="left-btn">
                  <van-button type="default" color="#6cc4da" class="filter-btn" @click="conditionClick(item,index)">
                    {{item.title}}
                    <i class="iconfont icon-youjiantou"></i></van-button>
                </div>
                <div class="right-label">
                  <div class="label-item" v-show="selectiveList[index].title">
                    <span>{{selectiveList[index].title | unicode2Natives}}</span>
                    <div class="close-icon" @click="deleteDefaultAttr(item,index)">
                      <img src="@/assets/img/close-icon.png" alt="" class="close-img">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--            <div class="label-container">
                          <div class="label-item" v-show="item.title" v-for="(item,index) in selectiveList" :key="index">
                            <span>{{item.title || ''}}</span>
                            <div class="close-icon" @click="deleteDefaultAttr(item,index)">
                              <img src="@/assets/img/close-icon.png" alt="" class="close-img">
                            </div>
                          </div>
                        </div>-->
            <div class="screen-result" v-if="modelList.length">
              <div class="header-screen">
                <div class="left-title">筛选结果</div>
                <div class="right-more" @click="modeMore" v-show="modelList.length > 3">
                  <span>更多({{modelList.length}})</span>
<!--                  {{whetherModel}}-->
                  <div class="icon">
                    <i class="iconfont icon-youjiantou" :class="whetherModel?'transform-up':''"></i>
                  </div>
                </div>
              </div>
              <div class="list">
                <div class="options" v-for="(item,index) in modelList" :key="index" v-show="item.show">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-bottom">
          <div class="option" @click="goDetails(item2,item)" v-for="item2 in item.product" :key="item2.id">
            <div class="img-cover">
              <!--              <img :src="cdnUrl+item.cover_img" alt="" class="img">-->
              <van-image :src="cdnUrl+item2.cover_img" fit="cover" alt="" class="img"/>
            </div>
            <div class="product-title ">{{item2.title}}</div>
          </div>
        </div>
        <div class="no-data" v-if="noProduct">
          <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">
          <p class="hint-text">暂无产品</p>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showBottomPosition"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker :columns="columns" value-key="title" :title="conditionTitlt" @change="onChange" show-toolbar
                  @cancel="onCancel" @confirm="onConfirm"/>
    </van-popup>
  </div>
</template>

<script>
import cdnUrl from '@/config/index'
import { getCondition, afreshFiltrate } from '@/api/product'
import { Native2Unicode, Unicode2Native } from '@/libs/util'

export default {
    data () {
        return {
            cdnUrl: cdnUrl.baseUrl.cdnUrl,
            showBottomPosition: false, // 底部弹出层
            columns: [],
            category_id: '',
            conditionList: [], // 筛选条件列表
            selectiveList: [], // 已选中的条件属性
            currentFiltrateBtn: {}, // 当前单击的筛选按钮的 标题 id 下标
            conditionTitlt: '',
            noProduct: false,
            modelList: [], // 型号列表数据
            attrId: [],
            whetherModel: false
        }
    },
    props: {
        // 产品列数据
        productList: {
            type: Array,
            default: function () {
                return []
            }
        },
        // 产品标题右侧的 '更多'
        showMoreBtn: {
            type: Boolean,
            default: false
        },
        // 筛选条件是否显示
        showFiltrate: {
            type: Boolean,
            default: false
        },
        // 应用筛选按钮是否显示
        applyFilterBtn: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        unicode2Natives (str) {
            if (str) {
                return Unicode2Native(str)
            } else {
                return ''
            }
        }
    },
    computed: {
        conditionListDispose () {
            if (this.conditionList.length !== 0) {
                return this.conditionList.filter(val => {
                    return val.attr.length !== 0
                })
            } else {
                return this.conditionList
            }
        }
    },
    watch: {
        productList: {
            handler: function (val, oldVal) {
                this.$toast.clear()
                // console.log('为啥还显示？？', val[0].product.length, val[0].product.length === 0)
                if (val[0].product.length === 0) {
                    this.noProduct = true
                } else {
                    this.noProduct = false
                }
            },
            deep: true
        }
    },
    created () {
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
    },
    mounted () {},
    methods: {
        gotoSucker () {
            this.$router.push({
                name: 'sucker',
            })
        },
        goRouter (url) {
            console.log(url);
            // this.$router.push({
            //     name: url,
            //     params: {
            //         refresh: true,
            //         type: 2
            //     }
            // })
            window.location.href = window.location.origin + '/eppendorf_single/index.html?from=singlemessage&isappinstalled=0#/centrifuge?type=2'
        },
        unicode2Natives (str) {
            return Unicode2Native(str)
        },
        onChange (picker, value, index) {
        // this.$toast(`当前值：${value}, 当前索引：${index}`)
        },
        onCancel () {
            this.showBottomPosition = false
        },
        // 单击了条件筛选确定按钮
        onConfirm (item) {
            var indexOf = this.currentFiltrateBtn.indexOf || 0
            this.selectiveList[indexOf] = item
            // console.log('单击了确定', item, this.category_id)
            this.confirmData()
            var ids = []
            this.selectiveList.map((val) => {
                if (val.id) {
                    ids.push(val.id)
                } else {
                    ids.push('')
                }
            })
            var params = {
                attr_id: item.id,
                category_id: this.category_id,
                selected_attr_id: this.attrId,
                selected_ids: ids
            }
            console.log('新确定属性params', params, this.selectiveList)
            this.afreshFiltratePort(params) // 重新获取筛选条件
            this.showBottomPosition = false
        },
        // 处理单击确定的数据
        confirmData () {
            // console.log('单击了确定', this.selectiveList)
            var attrId = []
            this.selectiveList.map((val) => {
                if (val.id) {
                    attrId.push(val.id)
                }
            })
            this.attrId = attrId
            this.$emit('attrFilterData', attrId)
        },
        // 单击了更多
        moreProduct (item) {
            this.$router.push(
                {
                    name: 'filterProduct',
                    query: {
                        // title: item.title,
                        category_id: item.id
                    }
                }
            )
        },
        // 单击了型号的更多
        modeMore () {
            // console.log('单击了型号的更多', this.whetherModel)
            this.whetherModel = !this.whetherModel
            this.disposeModelData(this.whetherModel, this.modelList)
        },
        // 单击了产品
        goDetails (item) {
            console.log(item,this.category_id)
            this.$router.push({
                name: 'productDetails',
                query: {
                    id: item.id,
                    showid: this.category_id
                }
            })
        },
        // 单击了条件
        conditionClick (item, index) {
            // 转码，有些东西在picker不显示
            console.log('[[[[[',item);
            var itemArr = JSON.parse(JSON.stringify(item))
            itemArr = itemArr.attr.map((val) => {
                val.title = Native2Unicode(val.title)
                return val
            })
            this.columns = itemArr
            this.showBottomPosition = true
            this.conditionTitlt = item.title || '筛选'
            // console.log(item, index)
            var currentFiltrateBtn = { ...item }
            currentFiltrateBtn.indexOf = index
            this.currentFiltrateBtn = currentFiltrateBtn
        },
        // 删除选择的 属性
        deleteDefaultAttr (item, index) {
            console.log('删除啊啊啊', item, index)
            this.selectiveList.splice(index, 1, [])
            var valueArr = Object.values(this.selectiveList)
            // console.log(666, valueArr)
            // 删除选中的属性时,如果都删了,重新获取所有条件
            this.confirmData()
            var selectBtn = 0
            valueArr.map((val) => {
                if (val.length !== 0) {
                    selectBtn++
                }
            })
            if (selectBtn === 0) {
                // console.log('打印还剩多少个btn', selectBtn)
                this.getConditionPort({ category_id: this.category_id })
            } else {
                var ids = []
                this.selectiveList.map((val) => {
                    if (val.id) {
                        ids.push(val.id)
                    } else {
                        ids.push('')
                    }
                })
                var params = {
                    attr_id: this.attrId[index - 1],
                    category_id: this.category_id,
                    selected_attr_id: this.attrId,
                    selected_ids: ids
                }
                // var params = {
                //   attr_id: this.attrId[index - 1],
                //   category_id: this.category_id,
                //   selected_attr_id: this.attrId
                // }
                // console.log('删除属性params', params)
                this.afreshFiltratePort(params) // 重新获取筛选条件
            }
        },
        // 处理型号筛选数据，(传false，默认显示前三个；传true，显示全部数据)
        disposeModelData (boolean, data) {
            if (data.length <= 3) {
                data.map((val) => {
                    val.show = true
                })
                this.modelList = data
            } else {
                if (boolean) {
                    data.map((val) => {
                        val.show = true
                    })
                    this.modelList = data
                } else {
                    data.map((val, key) => {
                        if (key <= 2) {
                            val.show = true
                        } else {
                            val.show = false
                        }
                    })
                    this.modelList = data
                }
            }
        },
        /** 网络请求 **/
        // 根据类别id 获取筛选条件
        getConditionPort (params) {
            this.category_id = params.category_id || ''
            getCondition(params).then(res => {
                if (res.errCode === 0) {
                    var data = res.data
                    // console.log('打印数据哦哦', data)
                    this.conditionList = data.condition
                    // 如果数据太长，默认显示前三个
                    this.disposeModelData(false, data.model)
                    // this.selectiveList.fill(['123'], 0, res.data.length)
                    this.selectiveList = new Array(data.condition.length).fill([])
                    // console.log('获取筛选条件', res.data)
                } else {
                    this.$toast(res.errMsg)
                }
            }).catch(err => {
                console.log('获取筛选条件失败', err)
                // this.$toast('获取筛选条件失败')
            })
        },
        // 条件下得属性改变，重新获取条件
        afreshFiltratePort (params) {
            afreshFiltrate(params).then(res => {
                // console.log('条件下得属性改变', res)
                if (res.errCode === 0) {
                    var data = res.data
                    data.condition.map((val, key) => {
                        this.conditionList[key].attr = val
                    })
                    // 如果数据太长，默认显示前三个
                    this.disposeModelData(false, data.model)
                }
            }).catch(err => {
                console.log('打印', err)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  @import "../scss/product";

  .product-content {
    flex: 1;
    background: #eeebf4 !important;
    padding-top: rem(66);
    .filter-button{
        width: rem(155);
        height: rem(36);
        border-radius: rem(5);
        color: #fff;
        font-size: rem(12);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 rem(10) 0 rem(6);
        // &:nth-child(1){
        //     background: #6DC6DC;
        //     border: 1px solid #0094B9;
        // }
        &:nth-child(1){
            background: #3664CD;
            border: 1px solid #1440A6;
        }
        .icon{
            width: rem(29);
            height: rem(29);
        }
        .text{}
        .icon-youjiantou{
            font-size: rem(13);
            transform: rotate(90deg);
        }
    }
  }
  .transform-up {
    transform: rotate(-180deg);
  }
  .right-goto-sucker {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: rem(143);
    height: rem(36);
    text-align: center;
    color: #fff;
    background-color: #6CC5DB;
    border-radius: rem(4);
    img {
        width: rem(24);
        height: rem(24);
    }
  }
</style>
